import api from '@/api/index.js'

const credit_debit_report = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_CREDIT_DEBIT_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_CREDIT_DEBIT_REPORT: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_CREDIT_DEBIT_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetCreditDebitReport({commit}, query) {
      let reqQueryStr = '';
      if (query.period.year) {
        reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_CREDIT_DEBIT_REPORT_ERROR', null)
      commit('SET_CREDIT_DEBIT_REPORT', null)
      commit('SET_CREDIT_DEBIT_REPORT_LOADING', true)
      return api.get('reports/credit-debit?' + reqQueryStr)
        .then((response) => {
          commit('SET_CREDIT_DEBIT_REPORT', response)
        })
        .catch((error) => {
          commit('SET_CREDIT_DEBIT_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_CREDIT_DEBIT_REPORT_LOADING', false)
        })
    }
  },
}

export default credit_debit_report
